/**
 * @fileoverview gRPC-Web generated client stub for accountsettings
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: accountsettings/accountsettings.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var promptoverridesources_promptoverridesources_pb = require('../promptoverridesources/promptoverridesources_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.accountsettings = require('./accountsettings_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountsettings.AccountSettingsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountsettings.AccountSettingsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetDateLimitResponse>}
 */
const methodDescriptor_AccountSettings_GetDateLimit = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetDateLimit',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetDateLimitResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetDateLimitResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetDateLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetDateLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getDateLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetDateLimit,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetDateLimitResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getDateLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetDateLimit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateDateLimitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateDateLimit = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateDateLimit',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateDateLimitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateDateLimitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateDateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateDateLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateDateLimit,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateDateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateDateLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateDateLimit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.ValidateImageTimestamps>}
 */
const methodDescriptor_AccountSettings_GetValidateImageTimestamps = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetValidateImageTimestamps',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.ValidateImageTimestamps,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.ValidateImageTimestamps.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.ValidateImageTimestamps)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.ValidateImageTimestamps>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getValidateImageTimestamps =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetValidateImageTimestamps,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.ValidateImageTimestamps>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getValidateImageTimestamps =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetValidateImageTimestamps);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateValidateImageTimestampsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateValidateImageTimestamps = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateValidateImageTimestampsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateValidateImageTimestamps =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateValidateImageTimestamps,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateValidateImageTimestamps =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateValidateImageTimestamps);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetAccountPromptOverrideSourceResponse>}
 */
const methodDescriptor_AccountSettings_GetAccountPromptOverrideSource = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetAccountPromptOverrideSourceResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetAccountPromptOverrideSourceResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetAccountPromptOverrideSourceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetAccountPromptOverrideSourceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getAccountPromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetAccountPromptOverrideSource,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetAccountPromptOverrideSourceResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getAccountPromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetAccountPromptOverrideSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateAccountPromptOverrideSourceRequest,
 *   !proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>}
 */
const methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateAccountPromptOverrideSourceRequest,
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse,
  /**
   * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.UpdateAccountPromptOverrideSourceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateAccountPromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateAccountPromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>}
 */
const methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetUsesNewAuditScanByDefaultResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getUsesNewAuditScanByDefault =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getUsesNewAuditScanByDefault =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateUsesNewAuditScanByDefault =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateUsesNewAuditScanByDefault =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetShowOldComplianceDashboardResponse>}
 */
const methodDescriptor_AccountSettings_GetShowOldComplianceDashboard = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetShowOldComplianceDashboardResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetShowOldComplianceDashboardResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetShowOldComplianceDashboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetShowOldComplianceDashboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getShowOldComplianceDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetShowOldComplianceDashboard,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetShowOldComplianceDashboardResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getShowOldComplianceDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetShowOldComplianceDashboard);
};


module.exports = proto.accountsettings;

